import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from "@material-ui/core";
import * as d3 from "d3";
import moment from "moment";

const popoverHeight = 200;

const styles = theme => ({
  root: {
    zIndex: 998,
    padding: theme.spacing.unit / 1.5,
    margin: theme.spacing.unit / 1.5,
    maxHight: popoverHeight
  },
  container: {
    padding: theme.spacing.unit / 1.5
  },
  detailButtonContainer: {
    paddingLeft: theme.spacing.unit
  },
  trendLabel: {
    paddingTop: theme.spacing.unit / 3,
    textAlign: "right"
  }
});

const formatDate = date => {
  return d3.time.format("%Y%m%dT%H%M%SZ").parse(date);
};

class HistoryEventPopover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onMouseEnter() {
    this.setState({ hovered: true });
  }

  onMouseLeave() {
    this.setState({ hovered: false });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // if hovered, fetching eventData from previous state
    if (nextProps.data === null && prevState.hovered) {
      return {
        data: prevState.data,
        clientRect: prevState.clientRect
      };
    }
    return {
      data: nextProps.data,
      clientRect: nextProps.clientRect
    };
  }

  render() {
    const { classes } = this.props;
    const { data, clientRect } = this.state;

    if (!data || !clientRect) {
      return null;
    }

    // console.log("history popover render");
    // console.log({ data });

    const { top, right, left, bottom } = clientRect;

    //console.log({ popoverClientRect });
    //console.log({ clientRect });

    const globalHeader = document.getElementsByClassName("sc-globalHeader");
    let globalHeaderHeight = 0;
    if (globalHeader && globalHeader.length > 0) {
      globalHeaderHeight = globalHeader[0].getBoundingClientRect().height;
    }

    const borderSize = 10;
    const popoverWidth = 200;
    const arrowStyle = {
      width: 10,
      height: 10,
      borderLeft: `{borderSize}px solid transparent`,
      borderRight: `{borderSize}px solid transparent`,
      borderTop: `{borderSize}px solid #000`,
      left: "45%",
      top: 10,
      position: 'relative',
      zIndex: 999
    };

    const style = {
      position: "absolute",
      // TODO: hard-coded pos the popover is defined within second tab
      // this needs major rework
      // I HATE CSS
      top: top - popoverHeight - borderSize * 3 - globalHeaderHeight,
      left: left - 200 + borderSize,
      bottom: bottom,
      width: popoverWidth
    };

    let pt = "none";
    if (data.changes.newRulesets !== undefined) {
      pt = data.changes.newRulesets.map(r => r.name).join(",");
    }

    let et = "";
    if (data.personalizationDetails.renderingRulesets !== undefined) {
      et = data.personalizationDetails.renderingRulesets.map(r => r.name).join(",");
    }

    return (
      <div
        style={style}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <Paper className={classes.root}>
          <Typography component="div" className={classes.container}>
            <Grid container direction="row" spacing={0}>
              <Grid item xs={10}>
                <Typography variant="title" component="h3">
                  {data.version}
                </Typography>
                <Typography className={classes.gutterBottom} component="p">
                  version
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={0}>
              <Grid item xs={10}>
                <Typography variant="title" component="h3">
                  {moment(formatDate(data.lastUpdated)).fromNow()}
                </Typography>
                <Typography className={classes.gutterBottom} component="p">
                  published
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={0}>
              <Grid item xs={10}>
                <Typography variant="title" component="h3">
                  {data.lastUpdatedBy}
                </Typography>
                <Typography className={classes.gutterBottom} component="p">
                  published by
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={0}>
              <Grid item xs={10}>
                <Typography variant="title" component="h3">
                  {pt}
                </Typography>
                <Typography className={classes.gutterBottom} component="p">
                  new personalization
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={0}>
              <Grid item xs={10}>
                <Typography variant="title" component="h3">
                  {et}
                </Typography>
                <Typography className={classes.gutterBottom} component="p">
                  all personalization
                </Typography>
              </Grid>
            </Grid>
          </Typography>
        </Paper>
        <div style={arrowStyle} />
      </div>
    );
  }
}

HistoryEventPopover.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
  // eventData: PropTypes.object.isRequired,
  // popoverClientRect: PropTypes.object.isRequired,
  // containerClientRect: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(HistoryEventPopover);



// WEBPACK FOOTER //
// ./src/components/HistoryEventPopover.js